<template>
    <div>
      <div class="produce-detail" v-html="demonReport">
       <!-- <h3>产品介绍</h3>
        <p>“中国知网”学位论文学术不端监测系统：简称知网VIP5.2/TMLC，是全国高校研究生院用来检测研究生毕业论文重复率的系统。最新版本数据库，检测结果与高校一致！可检测全日制，在职研究生，博士，MBA，同等学历等论文。VIP5.2与TMLC使用相同对比数据库，检测结果完全一样，只是称谓不同。</p>
      </div>
      <div class="produce-detail">
        <h3>产品参数</h3>
        <p>1、检测时间：30分钟-2小时（高峰期，系统拥堵，检测时间较长）</p>
        <p>2、论文格式：请提交word格式文档，知网系统不支持wps,pdf等论文格式。</p>
      </div>
      <div class="produce-detail">
        <h3>检测须知</h3>
        <p>1、请在提交前去除个人信息、学校信息，独创声明、图片和致谢</p>
        <p>2、系统不支持合篇检测，请勿将多篇论文合为一篇。</p>
      </div>-->
     </div>
    </div>
</template>

<script>
    export default {
        name: "system-detail",
        props: {
          demonReport:{
            type: String,
            default: ''
          }
        }
    }
</script>

<style scoped lang="scss">
  @import "../../assets/style/common";
  .produce-detail{
    h3{
      @include font(22px,#3b6bda);
      margin-top: 47px;
      font-weight: bold;
    }
    p{
      @include font(22px,#333);
      margin-top: 25px;
      line-height: 26px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/system-com/system-detail.vue